import { useLocation } from "react-router";
import LoginLayout from "../../shared-components/login-layout/login-layout";
import EmailOtpVerificationForm from "./email-otp-verification-form/email-otp-verification-form";

const EmailOtpVerification = () => {
  const { state } = useLocation();
  const { email, whereTo } = state;
  return (
    <LoginLayout
      title={"Verify Email"}
      subTitle={
        <>
          An OTP has been sent to{" "}
          <span className="text-color-mode">{email}</span> with 6 digits. Enter
          the OTP below to confirm Email.
        </>
      }
      showBackButton={false}
    >
      <EmailOtpVerificationForm whereTo={whereTo} email={email} />
    </LoginLayout>
  );
};

export default EmailOtpVerification;
